import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import { Market } from '@bridebook/toolbox/src/gazetteer';
import { ISupplierPackage } from '@bridebook/toolbox/src/map-packages-to-sections';
import { Box, ButtonV2 as Button, Divider } from '@bridebook/ui';
import { IconTickBold } from '@bridebook/ui/src/icons';
import componentStyles from './photographer-pricing-box.style';

interface IProps {
  supplierPackage: ISupplierPackage;
  currency: string;
  onShowMore?: () => void;
  market: Market;
}

const PhotographerPricingBox = ({ currency, market, onShowMore, supplierPackage }: IProps) => {
  const [showMore, setShowMore] = useState(supplierPackage.order === 0 ? true : false);
  const { t } = useTranslation('supplier');

  const toggleDetails = () => {
    if (onShowMore) onShowMore();
    setShowMore((prevState) => !prevState);
  };

  const { order, name, description, included, price } = supplierPackage;
  const formattedPrice = market.formatCurrency(price, {
    /**
     * TODO: [i18n] Is currency not the same as the market currency?
     */
    currency,
    maximumFractionDigits: 0,
  });

  const styles = componentStyles({ order });

  return (
    <Box style={styles.wrapper}>
      <Box m={6}>
        <Box>
          <Box flexDirection="row" justifyContent="space-between">
            <Box style={styles.name}>{name}</Box>
            <Box style={styles.priceWrapper}>
              <Box style={styles.from}>{t('supplier.packages.from')}</Box>
              <Box style={styles.price}>{formattedPrice}</Box>
            </Box>
          </Box>
          <Box style={styles.description}>{description}</Box>
          {!showMore && (
            <Box style={styles.showMore}>
              <Button variant="link" onClick={toggleDetails}>
                {t('supplier.packages.showDetails')}
              </Button>
            </Box>
          )}
        </Box>

        {showMore && (
          <>
            <Divider />
            <Box>
              <Box style={styles.whatsIncluded}>{t('supplier.packages.whatsIncluded')}</Box>
              <Box style={styles.includedItems}>
                {included?.map((item, index) => (
                  <Box alignItems="baseline" key={index} flexDirection="row" gap={2}>
                    <IconTickBold color="indigoCrush" />
                    <Box style={styles.includedItem}>{item}</Box>
                  </Box>
                ))}
              </Box>
            </Box>

            <Box alignItems="flex-start" pt={6}>
              <Button variant="link" onClick={toggleDetails}>
                {t('supplier.packages.hideDetails')}
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default PhotographerPricingBox;
